module.exports = __webpack_public_path__ + "img/mail.b505f47a.svg";